import { render, staticRenderFns } from "./OtherActivities.vue?vue&type=template&id=57c6d7c3&"
import script from "./OtherActivities.vue?vue&type=script&lang=js&"
export * from "./OtherActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports